import axios from "axios";
import { API } from "@/contexts/AuthContext";

// Phase 1 contracts live here so route and response details do not leak into
// the pages. There is deliberately no route fallback: a 404 is an integration
// error, not a reason to retry a different mutation endpoint.

export const phase1Api = {
  createTaskFromIntimation(intimacaoId, payload) {
    return axios.post(`${API}/kanban/intimacoes/${intimacaoId}/task`, payload, { withCredentials: true });
  },

  getCardActivity(cardId, { commentsPage = 1, commentsPageSize = 50 } = {}) {
    return Promise.allSettled([
      axios.get(`${API}/kanban/cards/${cardId}/comments`, { params: { page: commentsPage, page_size: commentsPageSize }, withCredentials: true }),
      axios.get(`${API}/kanban/cards/${cardId}/history`, { withCredentials: true }),
    ]).then(([comments, history]) => ({
      comments: comments.status === "fulfilled" ? (comments.value.data?.comments || comments.value.data?.items || comments.value.data || []) : [],
      commentsMeta: comments.status === "fulfilled" && !Array.isArray(comments.value.data) ? comments.value.data : null,
      history: history.status === "fulfilled" ? (history.value.data?.history || history.value.data || []) : [],
      commentsError: comments.status === "rejected",
      historyError: history.status === "rejected",
    }));
  },

  addComment(cardId, text) {
    return axios.post(`${API}/kanban/cards/${cardId}/comments`, { conteudo: text }, { withCredentials: true });
  },

  updateComment(cardId, commentId, text) {
    return axios.patch(`${API}/kanban/cards/${cardId}/comments/${commentId}`, { conteudo: text }, { withCredentials: true });
  },

  deleteComment(cardId, commentId) {
    return axios.delete(`${API}/kanban/cards/${cardId}/comments/${commentId}`, { withCredentials: true });
  },

  restoreCard(cardId) {
    return axios.post(`${API}/kanban/cards/${cardId}/restore`, {}, { withCredentials: true });
  },

  async getBoardMembers() {
    const boardsResponse = await axios.get(`${API}/kanban/boards`, { withCredentials: true });
    const board = boardsResponse.data?.boards?.[0];
    if (!board) return [];
    const boardResponse = await axios.get(`${API}/kanban/boards/${board.board_id}`, { withCredentials: true });
    return boardResponse.data?.members || [];
  },

  async findCardAcrossBoards(cardId) {
    const boardsResponse = await axios.get(`${API}/kanban/boards`, { withCredentials: true });
    const boards = boardsResponse.data?.boards || [];
    const details = await Promise.allSettled(boards.map((board) => axios.get(`${API}/kanban/boards/${board.board_id}`, { withCredentials: true })));
    for (let index = 0; index < details.length; index += 1) {
      if (details[index].status !== "fulfilled") continue;
      const data = details[index].value.data;
      const card = (data.cards || []).find((item) => item.card_id === cardId);
      if (card) return { board: boards[index], data, card };
    }
    return null;
  },

  getMorning() {
    return axios.get(`${API}/kanban/minha-manha`, { withCredentials: true });
  },

  getUpcomingAgenda() {
    return axios.get(`${API}/agenda/proximos`, { withCredentials: true });
  },

  getUntriagedIntimations() {
    return axios.get(`${API}/intimacoes`, { params: { triada: false, page: 1, page_size: 5 }, withCredentials: true });
  },
};

export const normalizeTask = (task) => task?.card || task?.task || task;
